import './Home.css';
import { useMemo } from 'react';
import { hotjar } from 'react-hotjar';
import { ContentLayout } from 'Molecules';
import { useAuth } from 'Providers/auth/AuthProvider.tsx';
import { isCelsiaSupport, isIssSales, isUserTwoWeeksOld } from 'utils/users';
import { useCurrentCompany } from 'utils/hooks';
import { useGetReportsQuery } from 'models';
import { HomeReportingFrameworks, HomeReportsCards, HomeWelcomeSection } from '.';
import { WelcomeModal } from './WelcomeModal.tsx';
import { HomeTaskBoard } from './HomeTaskBoard.tsx';
import { useFeatureFlags } from 'containers/Navigation/Navigation.hooks.tsx';

export const Home = () => {
  const { company } = useCurrentCompany();
  const { user } = useAuth();

  const companyId = useMemo(() => company?.id, [company]);

  const { data, loading } = useGetReportsQuery({
    variables: {
      companyId,
    },
    skip: !companyId,
  });

  const { hasSustainabilityAccess } = useFeatureFlags({ company });

  hotjar.identify(null, {
    isCelsia: isCelsiaSupport(user?.email),
    isIss: isIssSales(user?.email),
    isReal: company?.isReal,
    isTwoWeeksOld: isUserTwoWeeksOld(user?.createdAt),
    environment: import.meta.env.REACT_APP_NHOST_SUBDOMAIN,
  });

  const hasAssessments = useMemo(
    () =>
      !!data?.sustainabilityReportingAssessments.length ||
      !!data?.groupTaxonomyReports.length ||
      !!data?.paiCompanyReports.length ||
      !!data?.taxonomyReports.length,
    [data]
  );

  return (
    <ContentLayout header={''} isLoading={loading} variant="narrow">
      <HomeWelcomeSection user={user} />
      {hasSustainabilityAccess ? <HomeTaskBoard /> : <HomeReportingFrameworks />}
      {hasAssessments && <HomeReportsCards data={data} companyId={companyId} />}
      <WelcomeModal />
    </ContentLayout>
  );
};
